<aside
  class="layout-sidebar"
  [class.layout-sidebar-mobile]="isMobileViewport()"
  [class.layout-sidebar-mobile-visible]="isMobileOverlayOpen()"
  [style.width.px]="sidebarRenderWidth()"
  [attr.aria-hidden]="isMobileViewport() && !isMobileOverlayOpen() ? 'true' : null"
  [attr.inert]="isMobileViewport() && !isMobileOverlayOpen() ? '' : null"
  aria-label="Nawigacja boczna"
  role="navigation"
>
  <div class="sidebar-slot sidebar-slot-brand">
    <app-sidebar-brand
      class="block w-full min-w-0"
      [collapsed]="isCollapsedForView()"
      (toggleRequested)="toggleSidebar()"
      (homeRequested)="goToHome()"
    />
  </div>

  <div class="sidebar-slot sidebar-slot-nav">
    <app-sidebar-navigation
      class="block h-full w-full min-w-0"
      [collapsed]="isCollapsedForView()"
      [groups]="menuGroups()"
      (itemSelected)="onMenuItemSelected($event)"
    />
  </div>

  <div class="sidebar-slot sidebar-slot-user">
    <app-sidebar-user-panel
      class="w-full min-w-0 justify-center"
      [class.block]="!isCollapsedForView()"
      [class.flex]="isCollapsedForView()"
      [class.sidebar-user-panel-collapsed]="isCollapsedForView()"
      [collapsed]="isCollapsedForView()"
      [username]="username()"
      [userRole]="userRole()"
      [userInitials]="userInitials()"
      [backendVersion]="backendVersion()"
      [backendVersionLoading]="backendVersionLoading()"
      [backendVersionError]="backendVersionError()"
      [logoutInProgress]="logoutInProgress()"
      [logoutError]="logoutError()"
      (logoutRequested)="logout()"
    />
  </div>
</aside>

@if (isMobileOverlayOpen()) {
  <button
    type="button"
    class="layout-sidebar-backdrop"
    aria-label="Zamknij nawigację boczną"
    (click)="closeMobileSidebar()"
  ></button>
}
